var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useQueryClient } from '@tanstack/react-query';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useLanguage } from '@base/LanguageProvider';
import { TagType } from '@common/api';
import FSButton from '@components/FSButton';
import FSToggle from '@components/FSToggle';
import { useActionsByTagIdMap, useTagActions } from '@data/tag/tagActions';
import { useTagContext } from '@data/tag/tagContext';
import { TagQueryKeys } from '@data/tag/types';
import { useOutsideClick } from '@hooks/useOutsideClick';
import { ContextMenu } from '@shared/contextmenu';
import * as FarseerIcons from '@shared/icons/icons';
import Input from '@shared/input/Input';
import Manager from '@shared/modal/Manager';
import { Confirmation } from '@shared/modal/Simple';
import { IconBgButton } from '@styled/Button';
import { FlexRow, FlexRowRight } from '@styled/FlexWrappers';
import { TEBreadcrumb, TEChildGroup, TEChildGroupInner, TEChildGroupInnerBold, TEGroupSelector, TESearchBar, TEToolbar, TEWrapper, } from '@styled/TagEditor';
import DatabaseStatisticsModal from './DatabaseStatisticsModal';
import { getGenericUniqueTagName } from './menuItems';
import { calculateTagPerms, canCreateTagChildren } from './permissions';
import { TableTabs } from './TableTabs';
import { TagEditorTable } from './TagEditorTable';
import { TagGroup } from './TagGroup';
import { useTagTable } from './useTagTable';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../../../providers/AuthProvider';
var emptySearchFilter = {
    data: '',
    fields: ['name', 'description'],
    matchCase: false,
};
export function TagEditor() {
    var _this = this;
    var _a;
    var L = useLanguage().L;
    var navigate = useNavigate();
    var _b = useParams(), gId = _b.selectedGroupId, tId = _b.selectedTableId;
    var selectedGroupId = gId && gId !== '0' ? Number.parseInt(gId) : null;
    var selectedTableId = Number.parseInt(tId !== null && tId !== void 0 ? tId : '0');
    var tagActionsMap = (_a = useActionsByTagIdMap().data) !== null && _a !== void 0 ? _a : {};
    var user = useAuth().user;
    var queryClient = useQueryClient();
    var tagData = useTagContext().tagData;
    var _c = useTagActions(), createTag = _c.createTag, createMaterializedAccountTag = _c.createMaterializedAccountTag, editTag = _c.editTag;
    var _d = useTagTable(), tagTable = _d.tagTable, batchDeleteTagsHandler = _d.batchDeleteTagsHandler, removeCustomColumn = _d.removeCustomColumn, renameCustomColumn = _d.renameCustomColumn, selectedTagId = _d.selectedTagId, setSelectedTagId = _d.setSelectedTagId;
    useEffect(function () {
        var initialSelectedTagId = selectedTableId === 0 ? (selectedGroupId ? selectedGroupId : 0) : selectedTableId;
        if (initialSelectedTagId !== selectedTagId) {
            setSelectedTagId(initialSelectedTagId);
        }
    }, [selectedGroupId, selectedTableId]);
    var _e = __read(useState(false), 2), showGroupSelector = _e[0], setShowGroupSelector = _e[1];
    var _f = __read(useState([]), 2), expandedGroups = _f[0], setExpandedGroups = _f[1];
    var _g = __read(useState(emptySearchFilter), 2), searchFilter = _g[0], setSearchFilter = _g[1];
    var allGroups = tagData.groupTags;
    var cancelEditing = function () {
        setShowGroupSelector(false);
    };
    var wrapRef = useRef(null);
    useOutsideClick(wrapRef, cancelEditing, !showGroupSelector, true);
    var _h = __read(useState(0), 2), newlyAdded = _h[0], setNewlyAdded = _h[1];
    var selectGroupHandler = function (groupId) {
        var children = tagData.tagsByParentId[groupId || 'null'];
        var firstChild = children === null || children === void 0 ? void 0 : children.find(function (ch) { return ch.type === TagType.Table; });
        var tableId = firstChild ? firstChild.id : 0;
        navigate("/database/".concat(groupId ? groupId : 0, "/").concat(tableId));
        if (showGroupSelector) {
            setShowGroupSelector(false);
        }
        setSearchFilter(emptySearchFilter);
    };
    var selectTableHandler = function (tableId, groupId) {
        navigate("/database/".concat(groupId ? groupId : 0, "/").concat(tableId));
        if (showGroupSelector) {
            setShowGroupSelector(false);
        }
        setSearchFilter(emptySearchFilter);
    };
    var expandGroupHandler = function (groupId) {
        var newExpanded = __spreadArray([], __read(expandedGroups), false);
        if (newExpanded.includes(groupId)) {
            newExpanded = newExpanded.filter(function (id) { return id !== groupId; });
        }
        else {
            newExpanded.push(groupId);
        }
        setExpandedGroups(newExpanded);
    };
    var getSelectedGroupPath = function (selectedGroupId) {
        var title = [
            React.createElement(TEBreadcrumb, { key: "root", onClick: function () { return selectGroupHandler(null); } }, L('Root')),
        ];
        if (selectedGroupId) {
            var parents_1 = [];
            var getParentName_1 = function (parentId) {
                var parent = tagData.tagById[parentId];
                if (parent) {
                    parents_1.push(parent);
                    if (parent.ParentId) {
                        getParentName_1(parent.ParentId);
                    }
                }
            };
            getParentName_1(selectedGroupId);
            var _loop_1 = function () {
                var id = parents_1[i].id;
                title.push(React.createElement(TEBreadcrumb, { key: "span-bs-".concat(i) }, "/"));
                title.push(React.createElement(TEBreadcrumb, { key: "span-".concat(i), onClick: function () {
                        selectGroupHandler(id);
                    }, style: { fontWeight: i === 0 ? 'bold' : 'normal' } }, parents_1[i].name));
            };
            for (var i = parents_1.length - 1; i >= 0; i--) {
                _loop_1();
            }
        }
        return title;
    };
    var addGroupTag = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, createTag({
                        name: getGenericUniqueTagName(tagData.tagsByLowercase, 'Group'),
                        type: TagType.Group,
                        ParentId: selectedGroupId,
                    })];
                case 1:
                    _a.sent();
                    queryClient.invalidateQueries(TagQueryKeys.Tags);
                    if (selectedGroupId && !expandedGroups.includes(selectedGroupId)) {
                        expandGroupHandler(selectedGroupId);
                    }
                    setSearchFilter(emptySearchFilter);
                    return [2 /*return*/];
            }
        });
    }); };
    var addTableTag = function () { return __awaiter(_this, void 0, void 0, function () {
        var newTableTag;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, createTag({
                        name: getGenericUniqueTagName(tagData.tagsByLowercase, 'Table'),
                        type: TagType.Table,
                        ParentId: selectedGroupId,
                    })];
                case 1:
                    newTableTag = _a.sent();
                    queryClient.invalidateQueries(TagQueryKeys.Tags);
                    if (newTableTag && newTableTag.id) {
                        selectTableHandler(newTableTag.id, selectedGroupId);
                        setNewlyAdded(newTableTag.id);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var resetNewlyAdded = function () {
        if (newlyAdded !== 0) {
            setNewlyAdded(0);
        }
    };
    var changeTagParentHandler = function (tagId, newParentId) {
        var _a;
        var tag = tagData.tagById[tagId];
        if (tag === undefined) {
            return;
        }
        Manager.renderModal(React.createElement(Confirmation, { width: 400, title: React.createElement("span", null, L('Confirm move')), onOk: function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, editTag(__assign(__assign({}, tag), { ParentId: newParentId }))];
                        case 1:
                            _a.sent();
                            selectGroupHandler(selectedGroupId);
                            return [2 /*return*/];
                    }
                });
            }); } },
            React.createElement("span", null, "Are you sure you want to move ".concat(tag === null || tag === void 0 ? void 0 : tag.name, " to ").concat(newParentId ? (_a = tagData.tagById[newParentId]) === null || _a === void 0 ? void 0 : _a.name : 'Root', "?"))));
    };
    var childrenGroupsArr = useMemo(function () {
        var all = tagData.tagsByParentId[selectedGroupId ? selectedGroupId : 'null'] || [];
        return all.filter(function (tag) { return tag.type === TagType.Group; });
    }, [selectedGroupId, tagData.tagsByParentId]);
    var tagClassActions = user === null || user === void 0 ? void 0 : user.classActions.tagClassActions;
    // use group perms to check if variable/table/group can be added
    var group = selectedGroupId ? tagData.tagById[selectedGroupId] : undefined;
    var canAddTagToGroup = canCreateTagChildren(tagClassActions, tagActionsMap, group, true);
    // use table perms to check if dimension can be added and columns managed, and send them to table
    var table = selectedTableId ? tagData.tagById[selectedTableId] : undefined;
    var tableActions = calculateTagPerms(tagClassActions, tagActionsMap, table);
    return (React.createElement(TEWrapper, { className: "tiny-scrollbars" },
        React.createElement(TEToolbar, null,
            React.createElement(FlexRow, { style: { position: 'relative', alignItems: 'center' } },
                React.createElement(IconBgButton, { id: "hamburger-menu", onClick: function () { return setShowGroupSelector(!showGroupSelector); } },
                    React.createElement(FarseerIcons.Menu, null)),
                getSelectedGroupPath(selectedGroupId),
                React.createElement(ChildGroups, { children: childrenGroupsArr, selectGroupHandler: selectGroupHandler }),
                showGroupSelector && (React.createElement(TEGroupSelector, { ref: wrapRef },
                    React.createElement(FlexRowRight, null,
                        React.createElement(FSButton, { "$type": "secondary", title: L('Add Group'), disabled: !canAddTagToGroup, onClick: addGroupTag })),
                    React.createElement("div", { style: { maxHeight: 'calc(100vh - 200px)', overflow: 'overlay' } },
                        React.createElement(TagGroup, { groupId: null, selectedGroupId: selectedGroupId, tagsByParentId: tagData.tagsByParentId, tagByLowercaseName: tagData.tagsByLowercase, selectGroupHandler: selectGroupHandler, selectTableHandler: selectTableHandler, expandGroupHandler: expandGroupHandler, expanded: expandedGroups, tagActionsMap: tagActionsMap, user: user, allGroups: allGroups, changeTagParent: changeTagParentHandler }))))),
            React.createElement(FlexRow, null,
                React.createElement(FSButton, { "$type": "tertiary", "$color": "primary", title: L('Database Statistics'), style: { marginRight: 10 }, onClick: function () { return Manager.renderModal(React.createElement(DatabaseStatisticsModal, null)); } }),
                React.createElement(FSButton, { "$type": "secondary", "$color": "secondary", title: L('Add Variable'), disabled: !canAddTagToGroup, onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                        var newAcc;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, createMaterializedAccountTag(getGenericUniqueTagName(tagData.tagsByLowercase, 'Variable'), selectedGroupId)];
                                case 1:
                                    newAcc = _a.sent();
                                    queryClient.invalidateQueries(TagQueryKeys.Tags);
                                    if (newAcc) {
                                        selectTableHandler(0, newAcc.ParentId);
                                    }
                                    return [2 /*return*/];
                            }
                        });
                    }); } }),
                React.createElement(FSButton, { "$type": "secondary", "$color": "primary", title: L('Add Dimension'), style: { marginLeft: 10, whiteSpace: 'nowrap' }, disabled: !tableActions.canCreate, onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, createTag({
                                        name: getGenericUniqueTagName(tagData.tagsByLowercase, 'Dimension'),
                                        ParentId: selectedTableId,
                                        type: TagType.Dimension,
                                    })];
                                case 1:
                                    _a.sent();
                                    queryClient.invalidateQueries(TagQueryKeys.Tags);
                                    return [2 /*return*/];
                            }
                        });
                    }); } }))),
        React.createElement(TESearchBar, null,
            React.createElement(Input, { placeholder: "Search table", style: { width: '20%' }, value: searchFilter.data, onChange: function (e) { return setSearchFilter(__assign(__assign({}, searchFilter), { data: e.target.value })); } }),
            React.createElement(FSToggle, { title: "Name", checked: searchFilter.fields.includes('name'), onChange: function () {
                    if (searchFilter.fields.includes('name')) {
                        setSearchFilter(__assign(__assign({}, searchFilter), { fields: searchFilter.fields.filter(function (f) { return f !== 'name'; }) }));
                    }
                    else {
                        setSearchFilter(__assign(__assign({}, searchFilter), { fields: __spreadArray(__spreadArray([], __read(searchFilter.fields), false), ['name'], false) }));
                    }
                } }),
            React.createElement(FSToggle, { title: "Description", checked: searchFilter.fields.includes('description'), onChange: function () {
                    if (searchFilter.fields.includes('description')) {
                        setSearchFilter(__assign(__assign({}, searchFilter), { fields: searchFilter.fields.filter(function (f) { return f !== 'description'; }) }));
                    }
                    else {
                        setSearchFilter(__assign(__assign({}, searchFilter), { fields: __spreadArray(__spreadArray([], __read(searchFilter.fields), false), ['description'], false) }));
                    }
                } }),
            React.createElement(FSToggle, { title: "Connections", checked: searchFilter.fields.includes('connections'), onChange: function () {
                    if (searchFilter.fields.includes('connections')) {
                        setSearchFilter(__assign(__assign({}, searchFilter), { fields: searchFilter.fields.filter(function (f) { return f !== 'connections'; }) }));
                    }
                    else {
                        setSearchFilter(__assign(__assign({}, searchFilter), { fields: __spreadArray(__spreadArray([], __read(searchFilter.fields), false), ['connections'], false) }));
                    }
                } }),
            React.createElement(FSToggle, { title: "Match case", checked: searchFilter.matchCase, onChange: function () {
                    return setSearchFilter(__assign(__assign({}, searchFilter), { matchCase: !searchFilter.matchCase }));
                } })),
        React.createElement(TableTabs, { selectedGroupId: selectedGroupId, selectedTableId: selectedTableId, canAddTables: canAddTagToGroup, tagsByParentId: tagData.tagsByParentId, addTableTag: addTableTag, selectTableHandler: selectTableHandler, tagClassActions: tagClassActions, tagActionsMap: tagActionsMap, allGroups: allGroups, changeTagParent: changeTagParentHandler, newlyAdded: newlyAdded, resetNewlyAdded: resetNewlyAdded }),
        React.createElement(TagEditorTable, { tagTable: tagTable, batchDeleteTagsHandler: batchDeleteTagsHandler, removeCustomColumn: removeCustomColumn, renameCustomColumn: renameCustomColumn, selectedTagId: selectedTagId, selectedGroupId: selectedGroupId, selectTableHandler: selectTableHandler, tagType: selectedTableId ? TagType.Dimension : TagType.Account, tagSearchFilter: searchFilter, tableActions: tableActions, tagActionsMap: tagActionsMap })));
}
function ChildGroups(_a) {
    var children = _a.children, selectGroupHandler = _a.selectGroupHandler;
    var menuTriggerRef = useRef(null);
    if (children.length === 0) {
        return null;
    }
    var separatorIdx = 5;
    var children1 = [];
    var children2 = [];
    if (children.length > separatorIdx) {
        children1 = children.slice(0, separatorIdx);
        children2 = children.slice(separatorIdx, children.length);
    }
    else {
        children1 = children;
    }
    return (React.createElement(FlexRow, { style: { paddingLeft: 10, alignItems: 'center' } },
        React.createElement(FarseerIcons.ArrowRight, null),
        children1.map(function (ch) {
            return (React.createElement(TEChildGroup, { key: "group-".concat(ch.id), onClick: function () { return selectGroupHandler(ch.id); } },
                React.createElement(TEChildGroupInnerBold, null, ch.name.length > 12 ? "".concat(ch.name.substring(0, 10), "...") : ch.name),
                React.createElement(TEChildGroupInner, null, ch.name.length > 12 ? "".concat(ch.name.substring(0, 10), "...") : ch.name)));
        }),
        children2.length > 0 && (React.createElement(React.Fragment, null,
            React.createElement(IconBgButton, { ref: menuTriggerRef },
                React.createElement(FarseerIcons.ThreeDots, null)),
            React.createElement(ContextMenu, { items: children2.map(function (ch) {
                    return {
                        actionName: ch.name,
                        action: function () { return selectGroupHandler(ch.id); },
                    };
                }), triggerRefs: [{ ref: menuTriggerRef, trigger: 'click' }] })))));
}
// function AddFlowRibbon({
//     selectedGroupId,
//     selectedTableId,
// }: {
//     selectedGroupId: number | null;
//     selectedTableId: number | null;
// }) {
//     const { createTag, createMaterializedAccountTag } = useTagActions();
//     const queryClient = useQueryClient();
//     const [editingMode, setEditingMode] = useState(false);
//     const [tagName, setTagName] = useState('');
//     const keyDownHandler = async (e: any) => {
//         if (e.key === 'Enter') {
//             if (selectedTableId) {
//                 await createTag({
//                     name: tagName,
//                     type: TagType.Dimension,
//                     ParentId: selectedTableId,
//                 });
//                 queryClient.invalidateQueries(TagQueryKeys.Tags);
//             } else {
//                 await createMaterializedAccountTag(tagName, selectedGroupId);
//                 queryClient.invalidateQueries(TagQueryKeys.Tags);
//             }
//             setTagName('');
//             setEditingMode(false);
//         }
//     };
//     return (
//         <TEAddTagRibbon>
//             <BtnFlex onClick={() => setEditingMode(true)} style={{ width: '50px' }}>
//                 <Plus color={appColors.primary.w500} />
//             </BtnFlex>
//             {editingMode ? (
//                 <TETagInput
//                     autoComplete="on"
//                     type="text"
//                     value={tagName}
//                     name="tag"
//                     onChange={(e: any) => setTagName(e.target.value)}
//                     onKeyDown={keyDownHandler}
//                     style={{ paddingLeft: '30px', width: '252px' }}
//                 />
//             ) : (
//                 <TEAddTagLabel onClick={() => setEditingMode(true)}>New Tag</TEAddTagLabel>
//             )}
//         </TEAddTagRibbon>
//     );
// }
